
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M9.089 4.793v3.304h-2.42v4.04h2.42v12.008h4.973V12.138h3.337s.313-1.937.464-4.056h-3.782V5.32c0-.413.542-.969 1.078-.969h2.71V.145h-3.685C8.966.145 9.09 4.189 9.09 4.793Z","fill":"#1976D2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.268 .145)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    